import { bucharest, chi, chi2x, gurugram, gurugram2x, kiv, kiv2x, nj, nj2x } from "images/contact-us";
import { ReactNode } from 'react';

export interface IMapCard {
  title: string;
  description: ReactNode | string;
  mapImage: { origin: string; origin2x: string };
  email: string;
  googleMapLink: string;
  iframeLink: string;
  phone?: string;
}

export interface MapCardProps extends IMapCard {
  setSelectedLocation: (value: string | null) => void;
}

export const mapCardsData: IMapCard[] = [
  {
    title: 'Chisinau',
    description: 'Columna 104/1, MD-2005, Republic of Moldova',
    mapImage: { origin: kiv, origin2x: kiv },
    email: 'info@ussoftwaresolutions.us',
    googleMapLink: 'https://g.page/us-software-solutions',
    phone: '+373 698 99 930',
    iframeLink:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2719.5998616189204!2d28.823276000000003!3d47.0284588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c97d1fbcb3087f%3A0xfe57fbb718a6c2e9!2sUS%20Software%20Solutions%20-%20Moldova!5e0!3m2!1sen!2s!4v1664282577753!5m2!1sen!2s',
  },
  {
    title: 'Bucharest',
    description: 'Pitar Moș 6, București 030167, Romania',
    mapImage: { origin: bucharest, origin2x: bucharest },
    email: 'info@ussoftwaresolutions.us',
    googleMapLink: 'https://maps.app.goo.gl/LDxUf8LwnxJDLyka8',
    phone: '+40 756 156 688',
    iframeLink:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d178.03611108152575!2d26.1007431!3d44.4418225!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4f2baaf717%3A0x9019e74b345c968f!2sStrada%20Pitar%20Mo%C8%99%206%2C%20Bucure%C8%99ti%20030167%2C%20Romania!5e0!3m2!1sen!2s!4v1749452517880!5m2!1sen!2s',
  },
  {
    title: 'New Jersey',
    description: '5 Port Imperial Blvd APT 538, Weehawken Township, NJ 07086',
    mapImage: { origin: nj, origin2x: nj2x },
    email: 'info@ussoftwaresolutions.us',
    googleMapLink: 'https://maps.app.goo.gl/T4wZZZ51gJ8WfJ6d9',
    // phone: '',
    iframeLink:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.8351209876396!2d-74.01883339999999!3d40.765651!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2582e051edbd9%3A0x7043b35b2ec7ad02!2s5%20Port%20Imperial%20Blvd%20%23538%2C%20Weehawken%20Township%2C%20NJ%2007086%2C%20%D0%A1%D0%A8%D0%90!5e0!3m2!1sru!2s!4v1757056762419!5m2!1sru!2s',
  },
  {
    title: 'Gurugram',
    description: 'EMAAR Digital Green, Tower B, Floor 3, Golf Course Road Extension, Sector 61, Gurugram, Haryana – 122011',
    mapImage: { origin: gurugram, origin2x: gurugram2x },
    email: 'hr-india@ussoftwaresolutions.us',
    googleMapLink: 'https://maps.app.goo.gl/3SDv4NCQnhXwoHA39',
    phone: '+91 95994 42502',
    iframeLink:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d550.450742740634!2d77.09379181506529!3d28.41478113060392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d236bc8ba1ef5%3A0x9edc25704ef3f125!2sEmaar%20Digital%20Greens%20Tower%20B!5e0!3m2!1sru!2s!4v1790927418533!5m2!1sru!2s',
  },
  // {
  //   title: 'Chicago, IL',
  //   description: '1051 Perimeter Dr., Suite 510 Schaumburg, IL 60173',
  //   mapImage: { origin: chi, origin2x: chi2x },
  //   email: 'info@ussoftwaresolutions.us',
  //   googleMapLink: 'https://goo.gl/maps/eqH64kGqjxJqs4uK8',
  //   phone: '+1 630 283 0032',
  //   iframeLink:
  //     'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2962.7592930167557!2d-88.03425588455355!3d42.04834167920902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880faf933ab00007%3A0x8e066fcc450981d!2s1051%20Perimeter%20Dr%20%23510%2C%20Schaumburg%2C%20IL%2060173%2C%20USA!5e0!3m2!1sen!2sby!4v1631128836863!5m2!1sen!2sby',
  // },
];
